import { Button } from 'antd';
import { Mail } from 'lucide-react';

/** Under the password and two-factor steps: back to signing in with a code, which needs neither. */
export function LoginCodeOption({ onClick }: { onClick: () => void }) {
  return (
    <div className="mt-6 text-sm">
      <Button type="link" className="px-0" icon={<Mail className="size-4" />} onClick={onClick}>
        Sign in with a code instead
      </Button>
    </div>
  );
}
